import React, { Component } from "react";
import { connect } from "react-redux";
import KeyboardReact from "react-simple-keyboard";
import { layouts } from "../../../constants/layouts";
import FreeEmail from "./freeEmail";
import FreeGamers from "./freeGamers";
import FreeTeam from "./freeTeam";
import helmet from "../../../static/helmet.png";
import Progressbar from "../progressbar";
import "./free.scss";
import Gdpr from "../gdpr";
import FreeEnd from "./freeEnding";
const mapDispatchToProps = (dispatch) => {
  return {};
};
class ConnectedFreeRegister extends Component {
  emailForm = React.createRef();
  teamForm = React.createRef();

  state = {
    current: 0,
    email: "",
    teamName: "",
    inputName: "",
    layout: "default",
    teamId: null,
    keyboardVisible: true,
    timeOutId: null,
  };

  componentDidMount = () => {
    this.createNewTimeOut();
  };

  createNewTimeOut = () => {
    if (this.state.timeOutId !== null) {
      clearTimeout(this.state.timeOutId);
    }
    const timeOutId = setTimeout(() => {
      this.props.history.push("/");
    }, 120000);
    this.setState({ timeOutId: timeOutId });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  next = () => {
    this.setState({ current: this.state.current + 1, inputName: "" });
    this.createNewTimeOut();
  };

  prev = () => {
    this.setState({ current: this.state.current - 1, inputName: "" });
    this.createNewTimeOut();
  };

  setIds = (institutionId, categoryId) => {
    this.setState({ institutionId: institutionId, categoryId: categoryId });
  };

  setTeamId = (teamId) => {
    this.setState({ teamId: teamId });
  };

  onChangeAll = (inputs) => {
    if (this.state.inputName === "email") {
      this.emailForm.current.setFieldsValue({ email: inputs });
      this.setState({ email: inputs });
    } else if (this.state.inputName === "teamName") {
      this.teamForm.current.setFieldsValue({ teamName: inputs });
      this.setState({ teamName: inputs });
    }
  };

  setInputName = (event) => {
    this.setState({ inputName: event.target.id });
  };

  onKeyPress = (button) => {
    if (button === "{shift}" || button === "{lock}") {
      this.handleShift();
    }
  };

  handleShift = () => {
    const newLayoutName = this.state.layout === "default" ? "shift" : "default";
    this.setState({ layout: newLayoutName });
  };

  openKeyboard = () => {
    this.setState({ keyboardVisible: true });
  };

  closeKeyboard = () => {
    this.setState({ keyboardVisible: false });
  };

  render() {
    const steps = [
      {
        id: 0,
        title: "GDPR",
        description: "",
        ending: false,
        content: <Gdpr next={this.next} closeKeyboard={this.closeKeyboard} />,
      },
      {
        id: 1,
        title: "E-mail cím",
        description: "Az emlékek küldéséhez kérjük add meg az email címedet!",
        ending: false,
        content: (
          <FreeEmail
            formRef={this.emailForm}
            next={this.next}
            prev={this.prev}
            change={this.handleChange}
            email={this.state.email}
            setIds={this.setIds}
            setInputName={this.setInputName}
            submit={this.submitBasicData}
            openKeyboard={this.openKeyboard}
          />
        ),
      },
      {
        id: 2,
        title: "Hogyan szólíthatunk?",
        description: "A nyilvános ranglistán is ezen a néven jelensz meg!",
        ending: false,
        content: (
          <FreeTeam
            formRef={this.teamForm}
            next={this.next}
            prev={this.prev}
            email={this.state.email}
            teamName={this.state.teamName}
            change={this.handleChange}
            history={this.props.history}
            setInputName={this.setInputName}
            setTeamId={this.setTeamId}
            openKeyboard={this.openKeyboard}
          />
        ),
      },
      {
        id: 3,
        title: "Mutasd fel a kapott QR-kódot!",
        description:
          "Mostantól a QR kódod tárolja a megszerzett ezüstéréméket!",
        ending: false,
        content: (
          <FreeGamers
            next={this.next}
            prev={this.prev}
            teamName={this.state.teamName}
            email={this.state.email}
            history={this.props.history}
            setInputName={this.setInputName}
            setTeamId={this.setTeamId}
            teamId={this.state.teamId}
            closeKeyboard={this.closeKeyboard}
          />
        ),
      },
      {
        id: 4,
        title: "",
        description: "",
        ending: true,
        content: (
          <div>
            <FreeEnd
              history={this.props.history}
              closeKeyboard={this.closeKeyboard}
            />
          </div>
        ),
      },
    ];
    return (
      <div>
        <div>
          <div
            style={{
              padding: "1.5em",
              display: "flex",
              justifyContent: steps[this.state.current].ending
                ? "flex-end"
                : "space-between",
            }}
          >
            {!steps[this.state.current].ending && (
              <div>
                <div style={{ display: "flex" }}>
                  <div>
                    <img
                      alt="helmet"
                      src={helmet}
                      style={{ height: "70", width: "86px" }}
                    />
                  </div>
                  <h1 className="free-register-title">
                    {steps[this.state.current].title}
                  </h1>
                </div>
                <p className="free-register-subtitle">
                  {steps[this.state.current].description}
                </p>
              </div>
            )}
            <div>
              <Progressbar
                steps={steps}
                current={this.state.current}
                history={this.props.history}
              />
            </div>
          </div>
          <div /* className="steps-content" */>
            {steps[this.state.current].content}
          </div>
          {this.state.keyboardVisible && (
            <div style={{ position: "fixed", bottom: "0", width: "100%" }}>
              <KeyboardReact
                layout={layouts}
                layoutName={this.state.layout}
                onChange={(inputs) => this.onChangeAll(inputs)}
                keyboardRef={(r) => (this.keyboard = r)}
                inputName={this.state.inputName}
                onKeyPress={this.onKeyPress}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const FreeRegister = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedFreeRegister);
export default FreeRegister;
